import PropTypes from 'prop-types'
import { generateElementId } from '../../../../../common/helpers'
import classNames from 'classnames'
import styles from './index.module.scss'

const BlueSectionItem = ({ itemTitle, itemText }) => {
  return (
    <div
      className={classNames(
        'relative flex flex-col items-center lg:px-5',
        styles.blueSectionItem
      )}
      id={`blue-section-item-${generateElementId(itemTitle)}`}
    >
      <div className="-ml-2.5 mb-2 flex flex-row items-center justify-center">
        <p className="text-32 font-normal text-white lg:text-2xl lg:font-medium">
          {itemTitle}
        </p>
      </div>
      <p className="whitespace-normal text-center text-lg font-normal text-white lg:whitespace-pre-line">
        {itemText}
      </p>
    </div>
  )
}

BlueSectionItem.propTypes = {
  itemTitle: PropTypes.string.isRequired,
  itemText: PropTypes.string.isRequired,
}

export default BlueSectionItem
